import React from "react";
import PropTypes from "prop-types";
import styles from "./DownloadAgendaPDFButton.module.css";
import DownloadPDFIcon from "../../assets/pdf_Icon.svg";
import { MobileBridge } from "@wwg/mobile-bridge";

/**
 * A button that downloads the Meeting Agenda PDF.
 */
export function DownloadAgendaPDFButton({ pdfLink }) {
  const mobile = new MobileBridge();

  return (
    <button
      type="button"
      className={styles.button}
      onClick={() =>
        mobile.isApp() ? mobile.viewPDF(pdfLink) : mobile.openLink(pdfLink)
      }
    >
      <img
        className={styles.pdfIcon}
        src={DownloadPDFIcon}
        alt="PDF Download Icon"
      />
      <p className={styles.pdfText}>Meeting Agenda PDF</p>
    </button>
  );
}

DownloadAgendaPDFButton.propTypes = {
  /**
   * String that holds the link to the PDF file.
   */
  pdfLink: PropTypes.string.isRequired,
};
